import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import startCase from "lodash.startcase";
import MenuItem from "@material-ui/core/MenuItem";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    marginLeft: theme.spacing(2),
    "& .MuiSelect-select": {
      paddingTop: 0,
      paddingBottom: 0,
      marginBottom: -2,
      minWidth: 50,
      maxWidth: 150,
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
  label: {
    marginBottom: -1,
    marginRight: 4,
    fontSize: "1.1em",
    fontWeight: "bold",
  },
}));

export default function FilterStatus(props) {
  const classes = useStyles();
  const { onChange } = props;

  const statuses = ["scheduled", "complete", "past_due", "Queued"];
  return (
    <div className={classes.root}>
      <Typography component="div" variant="subtitle2" className={classes.label}>
        Status:{" "}
      </Typography>
      <FormControl>
        <Select
          defaultValue={"all"}
          onChange={(e) => {
            onChange(e.target.value);
          }}
        >
          <MenuItem value="all">All</MenuItem>
          {statuses.map((status, i) => (
            <MenuItem key={i} value={status}>
              {startCase(status)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
